import { surveyLocalization } from "../surveyStrings";

export var latvianSurveyStrings = {
  pagePrevText: "Atpakaļ",
  pageNextText: "Tālāk",
  completeText: "Pabeigt",
  progressText: "Lappuse {0} no {1}",
  emptySurvey: "Nav neviena jautājuma.",
  completingSurvey: "Pateicamies Jums par anketas aizpildīšanu!",
  loadingSurvey: "Ielāde no servera...",
  otherItemText: "Cits (lūdzu, aprakstiet!)",
  optionsCaption: "Izvēlēties...",
  requiredError: "Lūdzu, atbildiet uz jautājumu!",
  numericError: "Atbildei ir jābūt skaitlim.",
  textMinLength: "Lūdzu, ievadiet vismaz {0} simbolus.",
  minSelectError: "Lūdzu, izvēlieties vismaz {0} variantu.",
  maxSelectError: "Lūdzu, izvēlieties ne vairak par {0} variantiem.",
  numericMinMax:
    "'{0}' jābūt vienādam vai lielākam nekā {1}, un vienādam vai mazākam, nekā {2}",
  numericMin: "'{0}' jābūt vienādam vai lielākam {1}",
  numericMax: "'{0}' jābūt vienādam vai lielākam {1}",
  invalidEmail: "Lūdzu, ievadiet patiesu e-pasta adresi!",
  otherRequiredError: 'Lūdzu, ievadiet datus laukā "Cits"'
};

surveyLocalization.locales["lv"] = latvianSurveyStrings;
surveyLocalization.localeNames["lv"] = "latviešu";



// WEBPACK FOOTER //
// ./src/localization/latvian.ts


// WEBPACK FOOTER //
// webpack:///src/localization/latvian.ts